import React, { useReducer } from 'react';

import { AssociationContext } from './context';
import { defaultState, reducer } from './associateState';

export const AssociationProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(reducer, defaultState);
    return <AssociationContext.Provider value={{ state, dispatch }}>{children}</AssociationContext.Provider>;
};
